import React, {forwardRef, useEffect} from "react";
import {isEmbeddableElement} from "../../element/typeChecks";
import scripts from "./../VideoNotes/baidu/inject/webview.js?raw"
import styles from "./../VideoNotes/baidu/inject/webview.css?raw"
import {KEY_FILE_DIR} from "../../../../../src/Const";
import Global from "../../../../../src/global";
import {isBaiduVideoUrl} from "../../../../../src/utils";

const WebviewExt = forwardRef((props:{el:any,src:any,cacheEmbeddableRef?:any,source?:any}, ref) => {
    const {el,src} = props;
    useEffect(() => {
        const webview = document.getElementById(`excalidraw__iframe__outer${el.id}`);
        if (!webview) return;
        // webview.setAttribute('webpreferences', 'autoplayPolicy=document-user-activation-required');
        webview.addEventListener('dom-ready', () => {
            webview.executeJavaScript(`
                const new_style_element = document.createElement("style");
      new_style_element.textContent = \`${styles}\`;
      window.document.head.appendChild(new_style_element);
      `);
        });

        // webview.addEventListener('dom-ready', setupReferer);
        //
        // return () => {
        //     if (webview) {
        //         const session = webview.getWebContents().session;
        //         session.webRequest.onBeforeSendHeaders(null);
        //     }
        // };
    }, []);


    const setupReferer = () => {
        const webview = document.getElementById(`excalidraw__iframe__outer${el.id}`);
        if (!webview) return;

        const session = webview.getWebContents().session;

        // 为所有请求添加 Referer
        session.webRequest.onBeforeSendHeaders(
            { urls: ['*://*/*'] },
            (details, callback) => {
                details.requestHeaders['Referer'] = 'https://your-custom-referer.com';

                // 也可以根据 URL 动态设置 Referer
                if (details.url.includes('specific-domain.com')) {
                    details.requestHeaders['Referer'] = 'https://specific-referer.com';
                }

                callback({ cancel: false, requestHeaders: details.requestHeaders });
            }
        );
    };

    return <>
        <webview
            id={`excalidraw__iframe__outer${el.id}`}
            // ref={(ref) => props.cacheEmbeddableRef(el, ref)}
            className="excalidraw__embeddable iframe-content"
            preload={`file://${Global.g_appPath}webview_preload.js`}
            src={
                src?.type !== "document" ? (src?.link || el.link) : el.link
            }
            style={{marginLeft: '0.6px', marginTop: '0.6px',height:`${el.customData?.generationData?.originHeight || el.height}px`}}
            // https://stackoverflow.com/q/18470015
            scrolling={isEmbeddableElement(el) ? "yes" : "no"}
            referrerPolicy="strict-origin-when-cross-origin"
            title="Noteey Embedded Content"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
            webpreferences={props.source == 'canvas'?'autoplayPolicy=user-gesture-required':'autoplayPolicy=no-user-gesture-required'}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-downloads"
        />
    </>
})

export default WebviewExt;